import type { ReactNode} from "react";
import React, { createContext, useContext } from "react";
import {
	apiBaseWithoutTrailSlash,
	apiWithoutTrailSlash,
} from "../utils";

export interface ApiConfig {
	/** Base URL for v1 API (includes /api/v1). */
	overriddenBaseURL?: string;
	/** Base URL for v2 API (no version path, e.g. origin + /api). */
	overriddenBaseURLV2?: string;
	overriddenHeaders?: Record<string, string>;
}

const ApiConfigContext = createContext<ApiConfig | undefined>(undefined);

export const useApiConfig = (): ApiConfig => {
	const context = useContext(ApiConfigContext);

	if (!context) {
		return {
			overriddenBaseURL: apiWithoutTrailSlash(),
			overriddenBaseURLV2: apiBaseWithoutTrailSlash(),
			overriddenHeaders: {},
		};
	}

	return context;
};

interface ApiConfigProviderProps {
	children: ReactNode;
	config?: ApiConfig;
}

export function ApiConfigProvider({
	children,
	config = {},
}: ApiConfigProviderProps) {
	const defaultBaseURL = apiWithoutTrailSlash();
	const defaultBaseURLV2 = apiBaseWithoutTrailSlash();

	const mergedConfig: ApiConfig = {
		overriddenBaseURL: config.overriddenBaseURL || defaultBaseURL,
		overriddenBaseURLV2: apiBaseWithoutTrailSlash(config.overriddenBaseURLV2) || defaultBaseURLV2,
		overriddenHeaders: config.overriddenHeaders || {},
	};

	return (
		<ApiConfigContext.Provider value={mergedConfig}>
			{children}
		</ApiConfigContext.Provider>
	);
}

export default ApiConfigContext;
